import { Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { useGetQualificationDisplayLabels } from "@src/appV2/Qualifications/api/useGetQualificationDisplayLabels";
import { type ShiftAssignment } from "@src/appV2/redesign/Shift/Open/useGetShiftsSlotV2";
import { type ReactNode } from "react";

import { ProfileImage } from "./ProfileImage";

interface Props {
  shiftAssignment: ShiftAssignment;
  actions: ReactNode;
}

export default function WorkingThisShiftWorker(props: Props) {
  const { shiftAssignment, actions } = props;
  const { worker, workingAgentReq } = shiftAssignment;

  const { qualificationNameToDisplayLabelMap } = useGetQualificationDisplayLabels([
    workingAgentReq,
  ]);
  const qualificationDisplayLabel =
    qualificationNameToDisplayLabelMap.get(workingAgentReq) ?? workingAgentReq;

  return (
    <Stack direction="row">
      <Stack flex={1} flexDirection="row" alignItems="center" minWidth={0}>
        <Stack mr={4} flexShrink={0}>
          <ProfileImage
            firstName={worker.attributes.firstName}
            lastName={worker.attributes.lastName}
            src={worker.attributes.profileImageUrl}
            size="small"
          />
        </Stack>
        <Stack minWidth={0} flex={1}>
          <Text
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {worker.attributes.firstName} {worker.attributes.lastName}
          </Text>
          <Text
            variant="body2"
            sx={(theme) => ({
              color: theme.palette.text.secondary,
            })}
          >
            {qualificationDisplayLabel}
          </Text>
        </Stack>
      </Stack>
      <Stack flexDirection="row" alignItems="center" gap={2} flexShrink={0} ml={2}>
        {actions}
      </Stack>
    </Stack>
  );
}
